<template>
  <div>
    <div class="row">
      <div class="left">
        <Icon type="md-contact" />{{row.legalName}}</div>
      <div class="right">
        <Icon type="md-phone-portrait" class="hCenter" />{{row.legalPhone}}</div>
    </div>
    <div>
      <Icon type="md-home" class="hCenter" />{{row.companyName}}
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    row: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      selection: []
    }
  },
  computed: {},
  created() {},

  methods: {

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    }
  }
}

</script>
<style scoped lang="scss">
.div {
  font-size: 14px;
  color: #515a6e;
}

.row {
  display: flex;

  .left {
    flex: 1;
  }

  .right {
    flex: 1;
    text-align: right;
  }
}

.hCenter{
  vertical-align: baseline;
}
</style>
